"use client";

import { Box, Flex, Grid, Text } from "@chakra-ui/react";
import { useTranslations } from "next-intl";
import { useState } from "react";
import { HELP_CENTER_IDS } from "../_constants/help-center.ids";

export function AboutSection() {
  const tAbout = useTranslations("landing.wrappedInformation");
  const tHc = useTranslations("landing.help_center.about_section");
  const [activeIndex, setActiveIndex] = useState(0);

  const cards = [
    {
      scrollId: "about-story",
      tag: tAbout("story.tag"),
      title: tAbout("story.title"),
      body: tAbout("story.description"),
    },
    {
      scrollId: "about-vision",
      tag: tAbout("vision.tag"),
      title: tAbout("vision.title"),
      body: tAbout("vision.description"),
    },
    {
      scrollId: "about-roadmap",
      tag: tAbout("roadmap.tag"),
      title: tAbout("roadmap.title"),
      body: tAbout("roadmap.description"),
    },
  ];

  return (
    <Box id={HELP_CENTER_IDS.about.section}>
      <Flex id={HELP_CENTER_IDS.about.labelRow} align="center" gap={2} mb={3}>
        <Box
          id={HELP_CENTER_IDS.about.labelBar}
          w="20px"
          h="0.5"
          bg="primary.600"
          borderRadius="1px"
        />
        <Text
          id={HELP_CENTER_IDS.about.label}
          textStyle="11px"
          fontWeight="bold"
          letterSpacing="0.12em"
          textTransform="uppercase"
          color="primary.600"
        >
          {tHc("label")}
        </Text>
      </Flex>

      <Text
        id={HELP_CENTER_IDS.about.title}
        fontFamily="heading"
        textStyle={{ base: "xl", md: "2xl" }}
        fontWeight="bold"
        color="neutral.900"
        letterSpacing="-0.5px"
        mb={{ base: 6, md: 8 }}
      >
        {tHc("title")}
      </Text>

      <Grid
        id={HELP_CENTER_IDS.about.grid}
        templateColumns={{ base: "1fr", md: "repeat(1, 1fr)" }}
        gap={5}
      >
        {cards.map((card, i) => (
          <Box
            key={card.tag}
            id={card.scrollId}
            data-debug-id={HELP_CENTER_IDS.about.cardDebug(i + 1)}
            onClick={() => setActiveIndex(i)}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                setActiveIndex(i);
              }
            }}
            p={{ base: 5, md: 6 }}
            borderRadius="2xl"
            border="1px solid"
            borderColor={activeIndex === i ? "primary.500" : "neutral.200"}
            bg={activeIndex === i ? "primary.500" : "white"}
            cursor="pointer"
            transition="all 0.3s ease"
            transform={activeIndex === i ? "scale(1.02)" : "scale(1)"}
            boxShadow={
              activeIndex === i
                ? "0 20px 48px rgba(73, 77, 238, 0.24)"
                : "0 1px 3px rgba(0,0,0,0.04)"
            }
            _hover={{
              bg: activeIndex === i ? "primary.600" : "primary.50",
              borderColor: activeIndex === i ? "primary.600" : "primary.400",
              transform: activeIndex === i ? "scale(1.02)" : "translateY(-4px)",
            }}
            _focusVisible={{
              outline: "2px solid",
              outlineColor: "primary.400",
              outlineOffset: "2px",
            }}
          >
            <Text
              id={HELP_CENTER_IDS.about.cardTag(i + 1)}
              textStyle="xs"
              fontWeight="bold"
              letterSpacing="0.1em"
              color={activeIndex === i ? "whiteAlpha.900" : "primary.500"}
              textTransform="uppercase"
              mb={3}
            >
              {card.tag}
            </Text>
            <Text
              id={HELP_CENTER_IDS.about.cardTitle(i + 1)}
              fontFamily="heading"
              textStyle="2xl"
              fontWeight="bold"
              color={activeIndex === i ? "white" : "neutral.900"}
              mb={3}
              letterSpacing="-0.3px"
            >
              {card.title}
            </Text>
            <Text
              id={HELP_CENTER_IDS.about.cardBody(i + 1)}
              textStyle="sm"
              color={activeIndex === i ? "whiteAlpha.900" : "neutral.500"}
              lineHeight={1.7}
              whiteSpace="pre-line"
            >
              {card.body}
            </Text>
          </Box>
        ))}
      </Grid>
    </Box>
  );
}
